
<template>
   <v-layout row wrap>

      <v-flex class="sm12">
         <v-toolbar dense :color="err ? 'red' : 'green'" dark>
            <v-toolbar-title>
               <h6>{{ toolbarMessage }}</h6>
            </v-toolbar-title>
         </v-toolbar>
      </v-flex>

      <v-flex class="sm12">
         <shdl-code-mirror
            ref="editor"
            :value="editedText"
            :readOnly="readOnly"
            :selectedline="selectedline"
            :styleactiveline="styleactiveline"
            @change="codeChanged"
         ></shdl-code-mirror>
      </v-flex>

   </v-layout>
</template>


<script>

/* Voir Pegjs.org pour un Codemirror ajusté à la taille de l'écran :
function doLayout() {
    $("#left-column").height("0px");    // needed for IE
    $("#right-column").height("0px");   // needed for IE
    $(".CodeMirror").height("0px");
    $("#input").height("0px");

    $("#left-column").height(($("#left-column").parent().innerHeight() - 2) + "px");     // needed for IE
    $("#right-column").height(($("#right-column").parent().innerHeight() - 2) + "px");   // needed for IE
    $(".CodeMirror").height(($(".CodeMirror").parent().parent().innerHeight() - 14) + "px");
    $("#input").height(($("#input").parent().parent().innerHeight() - 14) + "px");
  }
*/

   import ShdlCodeMirror from '@/components/shdl/ShdlCodeMirror'

   import { checkModule } from '@/utilities/shdl/shdlAnalyser.js'
   import _ from 'lodash'
   import utilities from '@/utilities/shdl/shdlUtilities.js'

   export default {

      props: {
         module: Object,
      },

      components: {
         ShdlCodeMirror
      },

      data () {
         return {
            editedText: "",
            selectedline: 0,
            styleactiveline: null,
            err: null,
            equipotentialCount: null,
            unusedEquipotentialCount: null,
         }
      },

      mounted: function() {
         let mountedModule = this.$store.state.shdl.modules[this.module.id]
         this.editedText = mountedModule.text
         this.parseModule()
         // set editor height dynamically
         let element = this.$refs.editor.$el.parentElement
         element.style.height = (this.$store.state.appHeight - 233) + 'px'
      },

      beforeDestroy: function() {
         console.log('beforeDestroy...')
         this.saveIfModified(this.module.id)
      },

      watch: {
         'module.id': function (newVal, oldVal) {
            console.log('module.id changed from/to', oldVal, newVal)
            if (newVal) {
               this.saveIfModified(oldVal)
               let newModule = this.$store.state.shdl.modules[newVal]
               this.editedText = newModule.text
            }
         },
      },

      computed: {
         readOnly() {
            return !!this.module.locked_date
         },
         userOrTeamModuleIds () {
            return this.module.user ? this.$store.state.shdl.user2moduleList[this.module.user] : this.$store.state.shdl.team2moduleList[this.module.team]
         },
         toolbarMessage () {
            if (this.err) {
               let message = this.err.message
               let moduleName = this.err.module + ': ' || ''
               let locationDescription = this.err.location ? `line ${this.err.location.start.line}, column ${this.err.location.start.column}: ` : ''
               return `*** ${moduleName}${locationDescription}${message}`
            } else if (this.equipotentialCount) {
               if (this.unusedEquipotentialCount) {
                  return `Module OK, ${this.equipotentialCount} equipotentials (${this.unusedEquipotentialCount} unused)`
               } else {
                  return `Module OK, ${this.equipotentialCount} equipotentials`
               }
            }
         },
      },

      methods: {
         test () {
            let element = this.$refs.editor.$el.parentElement
            console.log(element.style)
            element.style.height = '550px'
         },
         save(moduleId) {
            let vuexModule = this.$store.state.shdl.modules[moduleId]
            vuexModule.text = this.editedText
            vuexModule.update_author = this.$store.state.loggedUserId
            try {
               return this.$store.dispatch('shdl/PUT_SHDL_MODULE', vuexModule)
            } catch(e) {
               this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de l'enregistrement", color: 'red' })
            }
         },
         saveIfModified (moduleId) {
            let vuexModule = this.$store.state.shdl.modules[moduleId]
            if (vuexModule && vuexModule.text != this.editedText) {
               this.save(moduleId)
            }
         },

         // triggered when user edits text, or when this.module.id is changed
         codeChanged (text) {
            console.log("code changed")
            this.editedText = text
            this.parseModuleDebounced()
         },

         parseModule: function() {
            console.log("parsing")
            // build a map (name -> module) for modules of same user/team
            let name2module = {}
            let self = this
            this.userOrTeamModuleIds.forEach(function(moduleId) {
               let module = self.$store.state.shdl.modules[moduleId]
               name2module[module.name] = module
            })
            
            // check module
            let { err, moduleList } = checkModule(this.module.name, name2module)

            this.err = err
            let module = name2module[this.module.name]
            if (err) {
               this.equipotentialCount = null
               this.unusedEquipotentialCount = null
            } else {
               this.equipotentialCount = utilities.equipotentialCount(module)
               this.unusedEquipotentialCount = utilities.unusedEquipotentialCount(module)
               // set module name according to text if changed
               if (module.structure.name !== module.name) {
                  console.log("changing name...")
                  module.name = module.structure.name
                  this.$store.dispatch('shdl/PUT_SHDL_MODULE', module)
               }
            }
            // commit checking info of all analysed modules in Vuex
            moduleList.forEach(module => {
               let { err, moduleList } = checkModule(module.name, name2module)
               this.$store.commit('shdl/UPDATE_MODULE_PARSE_INFO', {
                  moduleId: module.id,
                  structure: module.structure,
                  equipotentials: module.equipotentials,
                  isOk: !err,
               })
            })

            this.$forceUpdate()
         },
         
         parseModuleDebounced: _.debounce(function() {
            this.save(this.module.id)
            this.parseModule()
         }, 1000),

      },

  }

</script>



// WEBPACK FOOTER //
// ShdlEditor.vue?6c80d9a0